import React, { useEffect, useState } from "react";
import style from "./setting.module.scss";
import { Link, withRouter } from "react-router-dom";
import Button from "../Button/button"
import Input from "../input/input"
import Pagination from "../pagination/pagination"
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown"
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import disconnectTextGenerator from "../../helpers/actions/disconnectedText"
import Toast from "../Toast/Toast";
import GradientToast from "../gradientToast/Toast"
import numberWithCommas from "../../helpers/actions/numberWithCommas";
import toEnglishNumber from "../../helpers/actions/toEnglishNumber"
import ExceptionCard from "./exceptionCard/exceptionCard"
import { GetWalletSettings, CalculateTotalCost, GetSpecificPricingRangeVariant, EditPackage, EditSinglePricingRange } from "../../actions/APIcalls"
import Skeleton from "./skeleton"
import PricingDiagram from "./pricingDiagram/pricingDiagram"
import GeneralWarning from "../generalWarning/warning"


let timeRange = ['0.5', '1', '5', '15', '30']

const Setting = (props) => {

    const [exceptions, setExceptions] = useState({
        list: [
            { DKPC: '', specificPricingRange: '' },
        ],
        listCount: 0,
        pageCount: 0
    })
    const [selectedTimeRange, setSelectedTimeRange] = useState({
        time: '', timeError: '', variantCount: 100, variantError: '', perPrice: '', loading: false, generalPerPrice: 2.5, totalPrice: 0, times: 0,
        PAYG: {
            "250000": "15",
            "500000": "10",
            "1000000": "7.5",
            "1500000": "5",
            "100000000": "2.5"
        }
    })

    const [calculatePriceLoading, setCalculatePriceLoading] = useState({ loading: false })

    const [inputChange, setInputChange] = useState({
        typing: false,
        typingTimeout: null,
    })
    const [hasSkeleton, setHasSkeleton] = useState(true)
    const [toast, setToast] = useState('')

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    useEffect(async () => {
        await getSettingDetails()
        await getVariantList()
    }, []);

    const getSettingDetails = async () => {
        let res = await GetWalletSettings({ accountId: props.user.account._id })
        let tmpRes = selectedTimeRange;
        tmpRes.variantCount = res.data.activeProductsCount ? res.data.activeProductsCount : 0
        tmpRes.time = res.data.currentPricingRange ? res.data.currentPricingRange : 5
        if (res.data.PAYG) {
            tmpRes.PAYG = res.data.PAYG
            tmpRes.generalPerPrice = res.data.PAYG[Object.keys(res.data.PAYG).sort((a, b) => { return b - a })[0]]
        }
        setSelectedTimeRange({ ...tmpRes })
        determineInvoice()
        calculatePerPrice()
    }

    const calculatePerPrice = () => {
        let tmp = selectedTimeRange
        if (tmp.PAYG) {
            const iterator = Object.keys(selectedTimeRange.PAYG).sort((a, b) => { return b - a });
            let times = selectedTimeRange.time && selectedTimeRange.variantCount ? (43200 / selectedTimeRange.time) * selectedTimeRange.variantCount : 0;
            iterator.map(el => {
                if (times < Number(el)) {
                    tmp.perPrice = tmp.PAYG[el]
                }
            })
            setSelectedTimeRange({ ...tmp })
        }
    }

    const validateTime = time => {
        let res = true
        if (Number(toEnglishNumber(time)) < 1 || (Number(toEnglishNumber(time)) % 1 !== 0) || Number(toEnglishNumber(time)) > 60) {
            res = false
        }
        return res
    }

    const handleDelayedTimeRangeSelect = (type, time) => {
        if (time.toString() != '0.5') {
            let tmp = selectedTimeRange
            tmp.time = type == 'timeRange' ? time : toEnglishNumber(time.target.value.toString());
            tmp.timeError = ''
            setSelectedTimeRange({ ...tmp })

            if (inputChange.typingTimeout) {
                clearTimeout(inputChange.typingTimeout);
            }
            setInputChange({
                ...inputChange,
                typing: false,
                typingTimeout: setTimeout(function () {
                    handleTimeRangeSelect(type, time);
                }, 300),
            })
        }
    }

    const handleTimeRangeSelect = (type, time) => {
        if (time.toString() != '0.5') {
            let tmp = selectedTimeRange
            if (validateTime(type == 'timeRange' ? time : time.target.value)) {
                tmp.time = type == 'timeRange' ? time : toEnglishNumber(time.target.value.toString());
                tmp.timeError = ''
            } else {
                tmp.time = ''
                tmp.timeError = 'بازه زمانی غیر معتبر است.'
            }
            setSelectedTimeRange({ ...tmp })
            determineInvoice()
            calculatePerPrice()
        }
    }

    const handleVariantInput = (tag, value) => {
        let tmp = selectedTimeRange
        tmp.variantCount = toEnglishNumber(value.target.value.toString())
        setSelectedTimeRange({ ...tmp })
        // delayed variant request
        if (inputChange.typingTimeout) {
            clearTimeout(inputChange.typingTimeout);
        }
        setInputChange({
            ...inputChange,
            typing: false,
            typingTimeout: setTimeout(function () {
                determineInvoice()
            }, 500),
        })
        // end of delayed variant request
        // determineInvoice()
        calculatePerPrice()
    }

    const submitTimeChange = async () => {
        // change time range
        let tmp = selectedTimeRange
        tmp.loading = true
        setSelectedTimeRange({ ...tmp })
        if (selectedTimeRange.time) {
            let reqObject = {
                accountId: props.user.account._id,
                pricingRange: selectedTimeRange.time
            }
            let res = await EditPackage(reqObject, openToast)
            if (res && res.data && res.data.success) {
                props.history.push({
                    pathname: '/settinginvoice',
                    state: {
                        totalPrice: selectedTimeRange.totalPrice,
                        variantCount: selectedTimeRange.variantCount,
                        perPrice: selectedTimeRange.perPrice,
                        timeRange: selectedTimeRange.time,
                    }
                })
            } else {
                tmp.loading = false
                setSelectedTimeRange({ ...tmp })
            }
        } else {
            tmp.loading = false
            setSelectedTimeRange({ ...tmp })
        }
    }

    const determineInvoice = async () => {
        setCalculatePriceLoading({ ...calculatePriceLoading, loading: true })
        let tmp = selectedTimeRange
        tmp.times = selectedTimeRange.time && selectedTimeRange.variantCount ? (43200 / selectedTimeRange.time) * selectedTimeRange.variantCount : 0;
        tmp.totalPrice = 0
        let res = await CalculateTotalCost({ product_count: parseInt(selectedTimeRange.variantCount), pricing_range: parseFloat(selectedTimeRange.time) })
        if (typeof res != 'undefined' && res.data) {
            tmp.totalPrice = parseInt(res.data.amount / 10)
            tmp.times = parseInt(res.data.countPerMonth)
        } else {
            tmp.totalPrice = 0
        }
        setSelectedTimeRange({ ...tmp })
        setCalculatePriceLoading({ ...calculatePriceLoading, loading: false })
    }

    const getVariantList = async () => {
        setHasSkeleton(true)
        const params = {
            specificPricingRange: "*",
            countInPage: getFromUrl("countInPage"),
            page: getFromUrl("page"),
            query: getFromUrl("query")
        }
        let variantList = await GetSpecificPricingRangeVariant(params)
        if (variantList && variantList.data) {
            let tmpException = exceptions;
            tmpException.listCount = variantList.data.variantCount
            tmpException.pageCount = variantList.data.variantListPageCount
            tmpException.list = variantList.data.variantList

            if (tmpException.list.length < 1) {
                let emptyVariant = { DKPC: '', specificPricingRange: '' }
                tmpException.list.push(emptyVariant)
            }
            setExceptions({ ...tmpException })
        }
        setHasSkeleton(false)
    }

    const getFromUrl = (param) => {
        let defaultParams = {
            countInPage: 10,
            page: 1,
            query: ""
        }
        let url = new URLSearchParams(window.location.search);

        if (param) {
            if (url.get(param)) {
                return url.get(param)
            } else {
                return defaultParams[param];
            }
        } else {
            Object.keys(defaultParams).map(function (key, index) {
                if (url.get(key)) {
                    defaultParams[key] = url.get(key)
                }
            });

            return defaultParams
        }
    }

    const setToUrl = async (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        if (param != "salesStatus" && param != "productGroup" && param != "brand" && param != "channel") {
            await getVariantList();
        }
    }

    const editVariant = async (variant) => {
        let reqObject = {
            dkpc: toEnglishNumber(toPersianNumber(variant.DKPC)),
            pricingRange: variant.specificPricingRange ? toEnglishNumber(toPersianNumber(variant.specificPricingRange)) : null
        }
        let res = await EditSinglePricingRange(reqObject, openToast)
        // getVariantList again!
        await getVariantList();
    }

    const addVariantExceptionRow = () => {
        let tmpException = exceptions
        let newObject = { DKPC: '', specificPricingRange: '' }
        tmpException.list.unshift(newObject)
        setExceptions({ ...tmpException })
    }

    const openToast = (error) => {
        setToast(error)
    }

    const closeModalFunction = () => {
        setToast('')
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <Toast
                    tag='Toast'
                    text={toast}
                    value={toast ? true : false}
                    parentClose={closeModalFunction}
                />
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {
                    props.user.disconnected.status &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>{disconnectTextGenerator(props.user.disconnected.channelName)}</p>
                                <p className={style.expiredText}>جهت اتصال دوباره موبیشا به پنل، لطفا اطلاعات خود را در صفحه پنل دیجی‌کالا به‌روز رسانی کنید</p>
                                <Link className={style.expiredLink} to={'/channels'}>ورود به صفحه‌ی  پنل دیجی‌کالا  </Link>
                            </>
                        </GradientToast>
                    </div>
                }

                {/* <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <GeneralWarning />
                    </GradientToast>
                </div> */}

                <div className={style.header}>
                    <h1>تنظیمات</h1>
                </div>

                <div className={style.mainFlexWrapper}>
                    <div className={style.selectTimeWrapper}>
                        {/* Price Range Description */}
                        {/*<div className={style.descriptionWrapper}>
                             <PricingDiagram />
                        </div>*/}
                        {/* Price Range Description */}
                        <p className={style.selectTimedescription}>بازه‌ی قیمت‌گذاری مورد نظر خود را از گزینه‌های پیشنهادی انتخاب و یا وارد کنید.</p>
                        <div className={style.timesWrapper}>
                            {timeRange.map((time, index) => <div
                                key={index}
                                className={time == selectedTimeRange.time ? style.timeItemActive : style.timeItem}
                                style={time < 1 ? { opacity: '0.5', background: '#71717171', cursor: 'not-allowed' } : null}
                                onClick={() => handleDelayedTimeRangeSelect('timeRange', time)}
                            >
                                {toPersianNumber(time)}
                            </div>)}
                        </div>
                        <div className={style.infoBar}>
                            <span className={style.icon}>h</span>
                            <p className={style.text}>ممکن است حداکثر تا ۳۰ ثانیه زودتر از زمان اعلام شده قیمت‌گذاری انجام شود.</p>
                        </div>
                        <div className={style.timeInputWrapper}>
                            <Input
                                type="text"
                                disabled={false}
                                label={'بازه‌ی قیمت‌گذاری دلخواه (دقیقه)'}
                                withMinute={true}
                                placeholder="بازه‌ی قیمت‌گذاری دلخواه"
                                error={selectedTimeRange.timeError}
                                tag="desiredTimeRange"
                                value={selectedTimeRange.time ? selectedTimeRange.time : ''}
                                onchange={handleDelayedTimeRangeSelect}
                                onblur={() => { }}
                            />
                        </div>
                        <div className={style.buttonWrapper}>
                            <Button
                                loading={selectedTimeRange.loading}
                                disabled={false}
                                tag="confirmTimeChange"
                                type="solid"
                                label='تایید و تغییر بازه‌ی قیمت‌گذاری'
                                onclick={() => submitTimeChange()}
                            />
                        </div>
                    </div>
                    <div className={style.selectVariantWrapper}>
                        <div>
                            <p className={style.selectVariantDescription}>می‌توانید برای مشاهده تخمین هزینه‌ی ماهانه، تعداد تنوع‌های خود را وارد کنید.</p>
                            <div className={style.variantInputWrapper}>
                                <Input
                                    type="text"
                                    disabled={false}
                                    label={'تعداد تنوع‌ها'}
                                    placeholder='تعداد تنوع‌ها'
                                    error={selectedTimeRange.variantError}
                                    tag="variantInput"
                                    value={selectedTimeRange.variantCount ? selectedTimeRange.variantCount : ''}
                                    onchange={handleVariantInput}
                                    onblur={() => { }}
                                />
                            </div>
                        </div>

                        <div className={style.horizontalDashedLine}></div>

                        <div>
                            <div className={style.descFlexWrapper}>
                                <div className={style.flexItem}>تعداد قیمت‌گذاری ماهانه:</div>
                                <div className={style.flexItem}>{toPersianNumber(numberWithCommas(selectedTimeRange.times))} مرتبه</div>
                                <div className={style.flexItem}>هزینه قیمت‌گذاری هر تنوع:</div>
                                <div className={style.flexItem}>
                                    {!calculatePriceLoading.loading ?
                                        <>{selectedTimeRange.totalPrice && selectedTimeRange.variantCount ? toPersianNumber(numberWithCommas(parseInt(selectedTimeRange.totalPrice / selectedTimeRange.variantCount))) : toPersianNumber(0)}  تومان</>
                                        :
                                        <div className={style.loading}><span>.</span><span>.</span><span>.</span></div>
                                    }
                                </div>
                                <div className={style.flexItem}><p className={style.totalNumberTitle}>جمع کل:</p></div>
                                <div className={style.flexItem}>
                                    {!calculatePriceLoading.loading ?
                                        <p className={style.totalNumber}>{toPersianNumber(numberWithCommas(selectedTimeRange.totalPrice))} تومان</p>
                                        :
                                        <div className={style.loading}><span>.</span><span>.</span><span>.</span></div>
                                    }
                                </div>
                            </div>
                            <p className={style.warning}>(بدون احتساب تنوع‌های با بازه‌ی قیمت‌گذاری متفاوت)</p>
                            <div className={style.warningIconWrapper}>
                                <div className={style.icon}>h</div>
                                <div className={style.warningText}>جمع کل اعلامی، تخمینی برای تعداد تنوع وارد شده توسط شماست.
                                    در هر بار قیمت‌گذاری به اندازه‌ی مبلغ اعلام شده، از کیف پول شما کسر خواهد شد.</div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className={style.exceptionsWrapper}>
                    <div className={style.exceptionsHeader}>
                        <div className={style.paginationWrapper}>
                            <div className={style.pagination}>
                                <div className={style.Dropdown}>
                                    <Pagination
                                        tag="page"
                                        currentPage={parseInt(getFromUrl("page"))}
                                        pageCount={exceptions.pageCount}
                                        setPage={setToUrl}
                                    />

                                    <TinyDropdown
                                        placeholder={10}
                                        dropdownList={["10", "25", "50", "75", "100"]}
                                        selected={selected => {
                                            setToUrl(selected, 'countInPage')
                                        }}
                                        selectedItem={getFromUrl('countInPage')}
                                    />
                                    <div className={style.label}>تعداد نمایش در صفحه</div>
                                    <div className={style.verticalLine}></div>
                                    <div className={style.variantCount}>{toPersianNumber(numberWithCommas(exceptions.listCount))} نتیجه</div>
                                </div>
                            </div>
                        </div>
                        <h5 className={style.exceptionsTitle}>افزودن تنوع با بازه‌ی قیمت‌گذاری متفاوت</h5>
                    </div>

                    <button
                        className={style.addException}
                        onClick={() => addVariantExceptionRow()}
                    >
                        <div className={style.addIcon}>i</div>
                        <div className={style.addIconText}>افزودن ردیف</div>
                    </button>

                    <div className={style.listWrapper}>

                        <div className={style.hiddenListShadow}></div>
                        <div className={style.listWrapper}>
                            <div className={offset > 880 ? style.listHeaderShadowFixed : style.listHeaderShadow}>
                                <div className={style.listHeader}>
                                    <div className={style.listHeaderFlexItem228}>کد تنوع</div>
                                    <div className={style.listHeaderFlexItem228}>بازه قیمت‌گذاری</div>
                                    <div className={style.listHeaderFlexItem124}>تعداد قیمت‌گذاری<span>(ماهانه)</span></div>
                                    <div className={style.listHeaderFlexItem124}>جمع کل (ماهانه)<span>(ریال)</span></div>
                                    <div className={style.listHeaderFlexItem32}></div>
                                    <div className={style.listHeaderFlexItem32}></div>
                                </div>
                            </div>
                            <div className={style.listHeader}></div>
                            {/* render exception cards list */}
                            {exceptions.list && exceptions.list.map((exceptionItem, index) => <React.Fragment key={`exceptionItem_index`}>
                                <ExceptionCard
                                    key={index}
                                    data={exceptions.list[index]}
                                    perPrice={selectedTimeRange.generalPerPrice}
                                    editVariant={editVariant}
                                />
                            </React.Fragment>)}
                        </div>
                    </div>

                    <button
                        className={style.addException}
                        style={{ marginTop: '20px' }}
                        onClick={() => addVariantExceptionRow()}
                    >
                        <div className={style.addIcon}>i</div>
                        <div className={style.addIconText}>افزودن ردیف</div>
                    </button>

                </div>

            </div>
        );
    }
}

export default withRouter(Setting);
